import { Underconstruction } from "../WorkerComp/Utils"
export default function Works(){
    return(
        <>
        <Underconstruction name="Works"/>
        </>
       )
}